import { useCallback } from "react";
import { Modal } from "@mui/material";

import whiteCloseIcon from "assets/images/white-close-icon.svg";

import AppClientVideoModalDto from "dto/components/app-client-video-modal-dto";

const AppClientVideoModal = ({ isOpen, videoUrl, onClose }: AppClientVideoModalDto) => {
	const getYouTubeEmbedUrl = useCallback((url?: string) => {
		let videoId = undefined;

		if (!url) return undefined;

		if (url.includes("v=")) {
			videoId = url.split("v=")[1]?.split("&")[0];
		} else if (url.includes("youtu.be/")) {
			videoId = url.split("youtu.be/")[1];
		}

		if (!videoId) {
			return undefined;
		}

		return `https://www.youtube-nocookie.com/embed/${videoId}?disablekb=1&controls=0&showinfo=0&modestbranding=0&rel=0&playsinline=1&enablejsapi=1&autoplay=1&loop=1&mute=1&playlist=${videoId}`;
	}, []);

	if (!isOpen || !videoUrl) return null;

	const isYouTube = videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be");
	const isMp4 = videoUrl.includes(".mp4");

	return (
		<Modal open={isOpen} onClose={onClose} aria-labelledby="client-video-modal" aria-describedby="client-video-modal">
			<div className="app-client-video-modal">
				<div className="client-video-modal">
					<div className="client-video-modal__content">
						<button className="client-video-modal__close" onClick={onClose}>
							<img src={whiteCloseIcon} alt="Close modal" className="client-video-modal__close-icon" />
						</button>
						{isYouTube ? (
							<iframe
								width="100%"
								height="100%"
								src={getYouTubeEmbedUrl(videoUrl)}
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								title="YouTube video"
								className="client-video-modal__video"
							/>
						) : isMp4 ? (
							<video width="100%" height="100%" src={videoUrl} autoPlay controls className="client-video-modal__video" title="Video" />
						) : null}
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default AppClientVideoModal;
